import React from "react";
import "../../containers/ConfirmOpenTicket.css";
import { translations } from "../../containers/assets/translations";
import { ControlLabel, Button, FormGroup, FormControl } from "react-bootstrap";
import Autocomplete from "react-autocomplete";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default class SearchReservation extends React.Component {
  render() {
    return (
      <div>
        {this.props.showSearch ? (
          <div className="searchOptions col-md-12">
            <div className="col-12">
              <FormGroup bsSize="large" className="col-md-3 col-sm-6 col-xs-12">
                <ControlLabel>
                  {translations[this.props.lang]["PNR"]}
                </ControlLabel>
                <FormControl
                  className="well"
                  value={this.props.reservationNumber}
                  autoFocus
                  name="reservationNumber"
                  type="text"
                  maxLength={20}
                  onChange={event => {
                    this.props.handleChangeOfInputSearchFields(event);
                  }}
                />
              </FormGroup>
              <FormGroup bsSize="large" className="col-md-3 col-sm-6 col-xs-12">
                <ControlLabel>
                  {translations[this.props.lang]["Ticket Number"]}
                </ControlLabel>
                <FormControl
                  className="well"
                  value={this.props.ticketNumber}
                  name="ticketNumber"
                  type="text"
                  maxLength={20}
                  onChange={event => {
                    this.props.handleChangeOfInputSearchFields(event);
                  }}
                />
              </FormGroup>
              <FormGroup bsSize="large" className="col-md-3 col-sm-6 col-xs-12">
                <ControlLabel>
                  {translations[this.props.lang]["Company"]}
                </ControlLabel>
                <Autocomplete
                  value={this.props.companyDescription}
                  inputProps={{
                    className: "well form-control",
                    style: {
                      padding: 20,
                      backgroundColor: "#f5f5f5",
                      color: "#2e6da4",
                      fontWeight: 700,
                      display: "block",
                      fontSize: 16,
                      height: 46,
                      border: 1
                    }
                  }}
                  getItemValue={item => item.Name}
                  wrapperStyle={{
                    position: "relative",
                    display: "block",
                    fontSize: 16,
                    fontWeight: 900,
                    color: "#2e6da4",
                    height: 46,
                    lineHeight: 1.3333333,
                    zIndex: 10
                  }}
                  items={this.props.companies}
                  onSelect={(value, item, event) => {
					this.props.handleChangeOfCompany(item.Name, item.Code);
				  }}
                  renderItem={(item, isHighlighted) => (
                    <div
                      style={{
                        padding: 8,
                        background: isHighlighted ? "lightgray" : "white"
                      }}
                      key={item.Code}
                    >
                      {item.Name}
                    </div>
                  )}
                />
              </FormGroup>
              <div className="col-md-3 col-sm-6 col-xs-12">
                <ControlLabel>
                  {translations[this.props.lang]["Date"]}
                </ControlLabel>
                <button
                  className="btn btn-primary btn btn-lg date"
                  onClick={this.props.toggleCalendar}
                >
                  {this.props.date.format("DD/MM/YYYY")}
                </button>
                {this.props.isCalendarOpen && (
                  <DatePicker
                    minDate={new Date()}
                    selected={this.props.date}
                    onChange={this.props.handleChangeOfDate}
                    withPortal
                    inline
                  />
                )}
              </div>
            </div>
            <div className="col-md-12 no-positioning">
              <Button
                className="btn-primary btn-lg "
                bsSize="large"
                type="button"
                disabled={this.props.disableSearchReservationButton}
                onClick={this.props.fetchReservation}
              >
                {translations[this.props.lang]["Search Reservation"]}
              </Button>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/confirmOpenTicketComponents/SearchReservation.js